
import { getDateFromIso } from '../../../_helpers/stringHelper';
import MapComponent from '../../../common/components/map/MapComponent';
import { IServiceAgency } from '../../dwelling/reducers';
import { IKeyServiceOrdering } from '../../serviceOrdering/interfaces';

interface IOrderKeysProps {
  data?: IKeyServiceOrdering;
  agency: IServiceAgency;
}

const OrderKeys: React.FC<IOrderKeysProps> = ({ data, agency }) => {
  if (!data) {
    return <div>Aucune information de clé pour cette commande</div>;
  }

  return (
    <div className="orderPage-keys d-flex flex-column gap-3">
      <div className="orderPage-keys__element">
        <label>Status : </label>
        <div>{data.isAgency ? 'En agence' : data.lastStatus?.status.status}</div>
      </div>
      {!data.isAgency ? (
        <>
          <div className="orderPage-keys__element">
            <label>Détail : </label>
            <div>{data.lastStatus?.status.action}</div>
          </div>
          <div className="orderPage-keys__element">
            <label>Société : </label>
            <div>{data.societyName}</div>
          </div>
          <div className="orderPage-keys__element">
            <label>Contact : </label>
            <div>{data.contactName}</div>
          </div>
          <div className="orderPage-keys__element">
            <label>Tel : </label>
            <div>{data.societyPhone}</div>
          </div>
          <div className="orderPage-keys__element">
            <label>Email : </label>
            <div>{data.societyEmail}</div>
          </div>
          <div className="orderPage-keys__element">
            <label>Adresse : </label>
            <div>{data.address?.address}</div>
          </div>
          {data.comment && (
            <div className="orderPage-keys__element">
              <label>Infos. : </label>
              <div>{data.comment}</div>
            </div>
          )}
          <div className="orderPage-keys__element">
            <label>Disponibilités : </label>
            <div>
              {getDateFromIso(data.availabilityDate)} le {data.isMorningSchedule ? 'matin' : 'soir'}
            </div>
          </div>
          <MapComponent
            coordinates={
              data.address?.latitudeY && data.address?.longitudeX
                ? {
                    lat: Number(data.address?.latitudeY),
                    lng: Number(data.address?.longitudeX)
                  }
                : undefined
            }
            style={{
              borderRadius: '16px',
              height: '100%',
              width: '100%',
              minHeight: '250px'
            }}
          />
        </>
      ) : (
        <>
          <div className="orderPage-keys__element">
            <label>Nom : </label>
            <div>{agency.label}</div>
          </div>
          <div className="orderPage-keys__element">
            <label>Adresse : </label>
            <div>
              {agency.address.address} {agency.address.zip} {agency.address.city}
            </div>
          </div>
          {agency.address.additionalAddress && (
            <div className="orderPage-keys__element">
              <label>Complément : </label>
              <div>{agency.address.additionalAddress}</div>
            </div>
          )}
          <MapComponent
            coordinates={
              agency.address?.latitudeY && agency.address?.longitudeX
                ? {
                    lat: Number(agency.address?.latitudeY),
                    lng: Number(agency.address?.longitudeX)
                  }
                : undefined
            }
            style={{
              borderRadius: '16px',
              height: '100%',
              width: '100%',
              minHeight: '250px'
            }}
          />
        </>
      )}
    </div>
  );
};

export default OrderKeys;
